import React from 'react';
import './Grid.scss';

const Grid = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return <div className={`Grid-wrapper ${className || ''}`}>{children}</div>;
};

export { Grid };
